var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.597,
    height: 8.13,
    viewBox: "0 0 10.597 8.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5881",
    "data-name": "Path 5881",
    d: "M64.4,65.963l-5.972,6.054a.514.514,0,0,1-.745,0L55.229,69.5a.55.55,0,0,1,0-.757.514.514,0,0,1,.745,0l2.093,2.14,5.6-5.676a.514.514,0,0,1,.745,0,.539.539,0,0,1-.012.757",
    transform: "translate(-54.526 -64.547)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksTick);
export default __webpack_public_path__ + "static/media/tasks-tick.f6282009fa39b65efd9ef147e5e37e7f.svg";
export { ForwardRef as ReactComponent };